///ts:ref=Layer
/// <reference path="../../../pixi/display/Layer.ts"/> ///ts:ref:generated

namespace Game {
	export let paused = false;

	export let bulletsContainer: PIXI.Container;
	export let basesContainer: PIXI.Container;
	export let worldContainer: PIXI.Container;
	export let buildingsContainer: PIXI.Container;
	export let boomsContainer: PIXI.Container;
	export let uiLayer: PIXI.display.Layer;

	export let shadows: PIXI.display.Layer;
	export let layers: Array<PIXI.display.Layer>;
	export let dicts: Dicts;
	export let worldController: WorldController;
	export let statBar: StatBar;
	export let waveController: WaveController;
	export let corpsesContainer: PIXI.Container;

	export let mobPool: { [key: string]: Array<Bunny> } = {};

	export function start() {
		//everything is loaded, lets start the level!
		TileHasher.init();
		Background.init();

		MainLoop.onEnterFrame.addListener(update, 3);

		dicts = new Dicts();

		corpsesContainer = new PIXI.Container();
		corpses = corpsesContainer.children as any;

		worldContainer = new PIXI.Container();
		walking = worldContainer.children as any;

		buildingsContainer = new PIXI.Container();
		buildings = buildingsContainer.children as any;

		bulletsContainer = new PIXI.Container();
		bullets = bulletsContainer.children as any;

		boomsContainer = new PIXI.Container();
		booms = boomsContainer.children as any;

		basesContainer = new PIXI.Container();
		bases = basesContainer.children as any;

		//THREE LAYERS
		layers = [new PIXI.display.Layer(), new PIXI.display.Layer(), new PIXI.display.Layer()];
		uiLayer = new PIXI.display.Layer();

		//SHADOWS
		shadows = new PIXI.display.Layer();
		worldController = new WorldController(App.screen.width, App.screen.height, 30);


		App.stage.addChild(corpsesContainer);
		App.stage.addChild(shadows);
		App.stage.addChild(worldContainer);
		App.stage.addChild(basesContainer);
		App.stage.addChild(buildingsContainer);
		App.stage.addChild(layers[0]);
		App.stage.addChild(layers[1]);
		App.stage.addChild(boomsContainer);
		App.stage.addChild(layers[2]);
		App.stage.addChild(bulletsContainer);
		App.stage.addChild(uiLayer);

		initBases(7);

		App.stage.interactive = true;
		shadows.interactiveChildren = false;
		worldContainer.interactiveChildren = false;
		boomsContainer.interactiveChildren = false;
		bulletsContainer.interactiveChildren = false;
		buildingsContainer.interactiveChildren = false;

		Interact.init();
		statBar = new StatBar();
		statBar.createCounters();
		statBar.money = 4500;

		waveController = new WaveController(new WavesConfig());

		mobPool[DictNames.pony] = [];
		mobPool[DictNames.rabbit] = [];
		mobPool[DictNames.bear] = [];
	}

	export const targetFPMS = 1000.0 / 60.0;

	export let buildings: Array<Building>;
	export let walking: Array<Bunny>;
	export let bullets: Array<Bullet>;
	export let booms: Array<Boom>;
	export let bases: Array<Base>;
	export let corpses: Array<Corpse>;

	export let millisecondsAbsolute: number;

	export let shotEnabled: boolean = true;

	export function update(millisecondsDelta: number, millisecondsAbsolute: number) {
		Game.millisecondsAbsolute = millisecondsAbsolute;
		if (paused) return;

		let delta = millisecondsDelta / targetFPMS;
		delta = Math.min(delta, 3);

		waveController.update(millisecondsAbsolute);

		// ==== UPDATING CORPSES ===
		let j = 0;
		for (let i = 0; i < corpses.length; i++) {
			const child = corpses[i];
			//anim
			child.update(delta);
			if (!child.zombie) {
				corpses[j++] = child;
			} else {
				Background.stage.addChild(child);
			}
		}
		corpses.length = j;

		// ==== UPDATING BULLETS ===
		j = 0;
		for (let i = 0; i < bullets.length; i++) {
			const child = bullets[i];
			//anim
			child.updateMove(delta);
			if (!child.zombie) {
				bullets[j++] = child;
			} else {
				if (child.shooter && child.shooter.boomRadius > 0) {
					makeBoom(child.position.x, child.position.y, child.shooter);
				}
			}
		}
		bullets.length = j;

		///==== UPDATING BOOMS ====
		j = 0;
		for (let i = 0; i < booms.length; i++) {
			const child = booms[i];
			//anim
			child.update(delta);
			if (!child.zombie) {
				booms[j++] = child;
			}
		}
		booms.length = j;

		// ==== UPDATING MOBS ====

		j = 0;
		for (let i = 0; i < walking.length; i++) {
			const child = walking[i];
			//anim
			child.updateMove(delta, App.screen);
			if (!child.dead) {
				walking[j++] = child;
			} else {
				if (mobPool[child.name]) {
					mobPool[child.name].push(child);
				}
			}
			worldController.actorMoved(child);
		}
		walking.length = j;

		// ==== UPDATING WORLD ====

		if (shotEnabled) {
			worldController.makeShots(millisecondsAbsolute);
		}


		// ==== UPDATING BASES ====
		for (let i = 0; i < bases.length; i++) {
			const child = bases[i];
			child.update(delta);
		}

		// ==== UPDATING TURRETS ====
		j = 0;
		for (let i = 0; i < buildings.length; i++) {
			const child = buildings[i];

			if (child.zombie) {
				continue;
			}
			buildings[j++] = child;
			//logic
			child.updateShots(delta);
			//anim
			child.updateAnim(delta);

			worldController.actorMoved(child);
		}
		buildings.length = j;

		// if (buildings.length >= 2) {
		waveController.initIfNeeded();
		// }

		statBar.update();
		Interact.update(millisecondsAbsolute);
		Interact.updateLighting(delta);
	}

	export function makeBoom(screenX: number, screenY: number, bomber: Mob): void {
		setTimeout(() => {
			worldController.makeBoom(screenX, screenY, bomber);
			addBoomGraphics(screenX, screenY, bomber.boomRadius);
		}, bomber.reloadTimeout);
	}

	export function makeElectricEffect(): void {
	}

	export function makeWHATeffect(): void {
		for (let i = 0; i < 50; i++) {
			setTimeout(() => {
				spawnMob(dicts.pony, Math.random() * (App.screen.height - 200) + 100);
			}, Math.random() * 20000);
		}
	}

	export function addBoomGraphics(screenX: number, screenY: number, radius: number): void {
		let boom = new Boom();
		boom.anchor.set(0.45, 0.55);
		boom.scale.set(radius / 50);
		boom.position.set(screenX, screenY);
		boomsContainer.addChild(boom);

		let spr = new PIXI.Sprite(Assets.slot);
		spr.blendMode = Background.clearMode;
		spr.scale.set(2);
		spr.anchor.set(0.5);
		spr.position.set(screenX, screenY);
		Background.stage.addChild(spr);
	}

	export function spawnMob(proto: MobDict, y: number): Mob {

		let actor: Bunny;
		if (mobPool[proto.name] &&
			mobPool[proto.name].length > 0) {
			actor = mobPool[proto.name].pop();
		} else {
			if (proto.name == DictNames.pony) {
				actor = new Bunny(Assets.allMonsters[2], proto);
				actor.skins = Assets.allMonsters.slice(2, 5);
			} else if (proto.name == DictNames.bear) {
				actor = new Bunny(Assets.allMonsters[1], proto);
			} else {
				actor = new Bunny(Assets.allMonsters[0], proto);
			}
		}

		actor.position.set(0, y);
		actor.init();
		worldContainer.addChild(actor);
		return actor;
	}

	function initBases(num: number) {
		let screen = App.screen;
		for (let j = 0; j < 4; j++) {
			for (let i = 0; i < num; i++) {
				let base = new Base();
				base.position.set(screen.width - 100 - j * 90, (i + 0.5 - num / 2) * 90 + screen.height / 2);
				basesContainer.addChild(base);
			}
		}
	}
}
